import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

const InProgressComponent: React.FC = () => {
  return (
    <>
      <CircularProgress size={24} />
    </>
  )
}

export default InProgressComponent
